import React from "react";
import {
  WhmCard,
  WhmCardContent,
  WhmGrid,
  WhmSkeleton,
} from "@securitize/reactjs-whm";

export const DocumentsLoadingCard: React.FC = () => (
  <WhmCard
    variant={"outlined"}
    data-test-id="profile-documents-skeleton-card"
    sx={{
      margin: "0",
      width: "100%",
    }}
  >
    <WhmCardContent
      sx={{
        padding: "24px",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "8px",
          marginBottom: "16px",
        }}
      >
        <WhmSkeleton variant="rounded" width={120} height={20} />
        <WhmSkeleton variant="rounded" width={"100%"} height={20} />
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "8px",
          marginBottom: "16px",
        }}
      >
        <WhmSkeleton variant="rounded" width={"100%"} height={20} />
        <WhmSkeleton variant="rounded" width={"100%"} height={24} />
      </div>

      <WhmGrid container spacing={5}>
        {[1, 2, 3, 4, 5, 6].map((item) => (
          <WhmGrid item xs={12} lg={6} key={item}>
            <WhmSkeleton variant="rounded" height={162} />
          </WhmGrid>
        ))}
      </WhmGrid>
    </WhmCardContent>
  </WhmCard>
);
